import { post, put } from '../Services/http';
import { load as loadCart } from './Cart.action';
import { catchError } from './Error.action';

export const CHECKOUT_SET_SELECTED_COMPANY_ADDRESS = 'CHECKOUT_SET_SELECTED_COMPANY_ADDRESS';
export const CHECKOUT_SET_CUSTOMER_INFO = 'CHECKOUT_SET_CUSTOMER_INFO';
export const CHECKOUT_SET_PRIVATE_CUSTOMER = 'CHECKOUT_SET_PRIVATE_CUSTOMER';
export const CHECKOUT_SET_SIGN_UP = 'CHECKOUT_SET_SIGN_UP';
export const CHECKOUT_SET_DELIVERY = 'CHECKOUT_SET_DELIVERY';
export const CHECKOUT_SET_PAYMENT = 'CHECKOUT_SET_PAYMENT';
export const CHECKOUT_SET_COUNTRY = 'CHECKOUT_SET_COUNTRY';
export const CHECKOUT_SET_PAYMENTPLACE = 'CHECKOUT_SET_PAYMENTPLACE';
export const CHECKOUT_SET_COMPANYREFERENCE = 'CHECKOUT_SET_COMPANYREFERENCE';
export const CHECKOUT_SET_CAMPAIGN_CODE = 'CHECKOUT_SET_CAMPAIGN_CODE';
export const CHECKOUT_SET_ORDER_NOTE = 'CHECKOUT_SET_ORDER_NOTE';
export const CHECKOUT_ACCEPT_TERMS_OF_CONDITION = 'CHECKOUT_ACCEPT_TERMS_OF_CONDITION';
export const CHECKOUT_SUBMIT = 'CHECKOUT_SUBMIT';
export const CHECKOUT_SUBMIT_DONE = 'CHECKOUT_SUBMIT_DONE';
export const CHECKOUT_SUBMIT_ERROR = 'CHECKOUT_SUBMIT_ERROR';
export const CHECKOUT_SET_PAYMENT_WIDGET = 'CHECKOUT_SET_PAYMENT_WIDGET';
export const CHECKOUT_SHOW_FULL_FORM = 'CHECKOUT_SHOW_FULL_FORM';
export const CHECKOUT_SEARCH_COMPANY_ADDRESS = 'CHECKOUT_SEARCH_COMPANY_ADDRESS';
export const CHECKOUT_SET_REQUESTEDSHIPPINGDATE = 'CHECKOUT_SET_REQUESTEDSHIPPINGDATE';


const rootRoute = '/api/checkout';

export const setBusinessCustomer = (isBusinessCustomer) => ({
    type: CHECKOUT_SET_PRIVATE_CUSTOMER,
    payload: {
        isBusinessCustomer
    }
});

export const setSignUp = (signUp) => ({
    type: CHECKOUT_SET_SIGN_UP,
    payload: {
        signUp
    }
});
export const setAlternativeAddress = (propName, value) => ({
    type: CHECKOUT_SET_CUSTOMER_INFO,
    payload: {
        key: 'alternativeAddress',
        data: {
            [propName]: value
        }
    }
});

export const setCompanySearchAddress = (item) => (dispatch, getState) => {
    const { payload } = getState().checkout;
    return post(rootRoute + '/getaddressbysearch', item, payload)
        .then(response => response.json())
        .then((data) => dispatch({
            type: CHECKOUT_SEARCH_COMPANY_ADDRESS,
            payload: data,
        }))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));

};
export const setRequestedShippingDate = (requestedDateValue) => (dispatch) => {
    dispatch({
        type: CHECKOUT_SET_REQUESTEDSHIPPINGDATE,
        payload: {
            requestedShippingDate: requestedDateValue
        }
    });
}
export const setCustomerDetails = (propName, value) => {
    return ({
        type: CHECKOUT_SET_CUSTOMER_INFO,
        payload: {
            key: 'customerDetails',
            data: {
                [propName]: value
            }
        }
    })
};

export const setSelectedCompanyAddress = (selectedCompanyAddressId) => ({
    type: CHECKOUT_SET_SELECTED_COMPANY_ADDRESS,
    payload: {
        selectedCompanyAddressId,
        searchCompanyAddress: null
    }
});

export const setDeliveryMethods = (deliveryMethods) => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_DELIVERY,
        payload: {
            deliveryMethods
        }
    });
    const { payload } = getState().checkout;
    return put('/api/checkout/setDeliveryProvider', payload)
        .then(response => response.json())
        .then(() => dispatch(loadCart()))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
};

export const setDelivery = (systemId) => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_DELIVERY,
        payload: {
            selectedDeliveryMethod: systemId
        }
    });
    const { payload } = getState().checkout;
    return put('/api/checkout/setDeliveryProvider', payload)
        .then(response => response.json())
        .then(() => dispatch(loadCart()))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
};

export const setPayment = (systemId) => (dispatch, getState) => {
    dispatch({
        type: CHECKOUT_SET_PAYMENT,
        payload: {
            selectedPaymentMethod: systemId
        }
    });
    const { payload } = getState().checkout;
    return put('/api/checkout/setPaymentProvider', payload)
        .then(response => response.json())
        .then(result => {
            dispatch(loadCart());
            dispatch(setPaymentWidget(result.paymentWidget));
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
};

export const updateCountry = (countryId) => (dispatch, getState) => {
    dispatch(setCustomerDetails('country', countryId));

    const { payload } = getState().checkout;

    return put('/api/checkout/GetDeliveryProviders', payload)
        .then(response => response.json())
        .then((response) => dispatch(setDeliveryMethods(response)))
        .then(() => dispatch(loadCart()))
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
};


export const setPaymentPlace = (costCenterValue) => (dispatch) => {
    dispatch({
        type: CHECKOUT_SET_PAYMENTPLACE,
        payload: {
            selectedPaymentPlace: costCenterValue
        }
    });
    const $elList = document.getElementById("selectPaymentPlaceList");
    return post(rootRoute + '/setpaymentplace', $elList ? $elList.value : costCenterValue)
        .then(response => response.json())
        .then(function () {
            window.location.reload();
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
};

export const setCompanyReference = (companyReferenceValue) => (dispatch) => {
    dispatch({
        type: CHECKOUT_SET_COMPANYREFERENCE,
        payload: {
            selectedCompanyReference: companyReferenceValue
        }
    });
    const $elList = document.getElementById("selectCompanyReferenceList");
    return post(rootRoute + '/setcompanyreference', $elList ? $elList.value : companyReferenceValue)
        .then(response => response.json())
        .then(function () {
            window.location.reload();
        })
        .catch(ex => dispatch(catchError(ex, error => submitError(error))));
};

export const reloadPayment = () => (dispatch, getState) => {
    const { paymentWidget, selectedPaymentMethod } = getState().checkout.payload;
    if (!paymentWidget) {
        return;
    }
    return dispatch(setPayment(selectedPaymentMethod));
};

const setPaymentWidget = (paymentWidget) => ({
    type: CHECKOUT_SET_PAYMENT_WIDGET,
    payload: {
        paymentWidget
    }
});

export const setOrderNote = (orderNote) => ({
    type: CHECKOUT_SET_ORDER_NOTE,
    payload: {
        orderNote
    }
});

export const acceptTermsOfCondition = (acceptTermsOfCondition) => ({
    type: CHECKOUT_ACCEPT_TERMS_OF_CONDITION,
    payload: {
        acceptTermsOfCondition
    }
});

export const setCampaignCode = (campaignCode) => ({
    type: CHECKOUT_SET_CAMPAIGN_CODE,
    payload: {
        campaignCode
    }
});

export const submitCampaignCode = () => (dispatch, getState) => {
    const { payload } = getState().checkout;
    return put('/api/checkout/setCampaignCode', payload)
        .then(response => response.json())
        .then(result => {
            dispatch(loadCart());
            // reset error of campaign code
            dispatch(submitError({
                modelState: {
                    'campaignCode': []
                }
            }));
        })
        .catch(ex => {
            dispatch(catchError(ex, error => submitError(error)));
            // restore the initial cart
            dispatch(loadCart());
        });
};

export const submit = () => (dispatch, getState) => {
    const { payload } = getState().checkout;
    let { addressExtra, address } = payload.alternativeAddress;
    const deliminator = '| ';

    // Clean address from ev pipes
    if (address && address.includes(deliminator)) {
        address = address.split(deliminator)[0].trim();
        payload.alternativeAddress.address = address;
    }

    // If addressExtra contains deliminator, Take the second part
    if (addressExtra && addressExtra.includes(deliminator)) {
        const parts = addressExtra.split(deliminator);
        addressExtra = parts.length > 1 ? parts[1].trim() : parts[0].trim();
    }

    // Combine address with addressExtra
    if (addressExtra) {
        payload.alternativeAddress.address = address + deliminator + addressExtra;
    }
    return _submit('/api/checkout', payload, dispatch);
};

export const validateOrder = () => (dispatch, getState) => {
    const { payload } = getState().checkout;
    return post('/api/checkout/validateorder', payload)
        .then(response => response.json())
        .catch(ex => {
            dispatch(catchError(ex, error => submitError(error)));
            dispatch(loadCart());
            return false;
        });
};

export const verify = (url, orderId, payload) => (dispatch, getState) => {
    const model = getState().checkout.payload;
    model.orderId = orderId;
    model.payload = payload;
    return _submit(url, model, dispatch);
};

const _submit = (url, model, dispatch) => {
    return post(url, model)
        .then(response => response.json())
        .then(result => {
            dispatch(submitDone(result));
        })
        .catch(ex => {
            if (ex.response) {
                ex.response.json().then(error => {
                    dispatch(submitError(error));
                    dispatch(submitDone(null));
                });
            } else {
                dispatch(submitError(ex));
            }
        });
};

export const setPerson = () => (dispatch) => {
    const $elList = document.getElementById("selectOrgPersonList");

    if ($elList) {
        //const personId = $elList.value;
        return post(rootRoute + '/setperson', $elList.value)
            .then(response => response.json())
            .then(function (reply) {
                window.location.reload();
            })
            .catch(ex => dispatch(catchError(ex, error => submitError(error))));
    }
};

export const toggleShowFullForm = () => (dispatch, getState) => {
    dispatch(show(!getState().checkout.showFullForm));
};
//export const showFullFormState = () => (getState) => {
//    return getState().checkout.showFullForm;
//}

export const show = (visible) => ({
    type: CHECKOUT_SHOW_FULL_FORM,
    payload: {
        showFullForm: visible
    }
});

export const submitRequest = () => ({
    type: CHECKOUT_SUBMIT,
    payload: {
        isSubmitting: true,
        errors: []
    }
});

export const submitDone = result => ({
    type: CHECKOUT_SUBMIT,
    payload: {
        result,
        isSubmitting: false
    }
});

export const submitError = error => ({
    type: CHECKOUT_SUBMIT_ERROR,
    payload: {
        error
    }
});
